"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findVoters = exports.findRegistrars = exports.voter = exports.registrar = void 0;
async function registrar(program, address) {
    return program.account.registrar.fetch(address);
}
exports.registrar = registrar;
async function voter(program, address) {
    return program.account.voter.fetch(address);
}
exports.voter = voter;
async function findRegistrars({ program, splGovProgramId, realm, realmGoverningToken, }) {
    const filters = [];
    if (splGovProgramId) {
        filters.push({
            memcmp: {
                bytes: splGovProgramId.toBase58(),
                offset: 8, // 8 anchor offset
            },
        });
    }
    if (realm) {
        filters.push({
            memcmp: {
                bytes: realm.toBase58(),
                offset: 40, // 8 anchor offset + first data 32B spl program id
            },
        });
    }
    if (realmGoverningToken) {
        filters.push({
            memcmp: {
                bytes: realmGoverningToken.toBase58(),
                offset: 72, // 8 anchor offset + first data 32B spl program id + 32B realm
            },
        });
    }
    return await program.account.registrar.all(filters);
}
exports.findRegistrars = findRegistrars;
async function findVoters({ program, voterAuthority, registrar, }) {
    const filters = [];
    if (voterAuthority) {
        filters.push({
            memcmp: {
                bytes: voterAuthority.toBase58(),
                offset: 8, // 8 anchor offset
            },
        });
    }
    if (registrar) {
        filters.push({
            memcmp: {
                bytes: registrar.toBase58(),
                offset: 40, // 8 anchor offset + first data 32B voter authority
            },
        });
    }
    return await program.account.voter.all(filters);
}
exports.findVoters = findVoters;
//# sourceMappingURL=api.js.map